import { createContext, useContext, useEffect, useState } from "react";
import { getDocs, getMenu } from "../components/action";
import { useAuth } from "../components/ProtectedRoute/PrivateRoutes";
import { getFooter } from "../pages/admin/components/actions";

const AppContext = createContext()

 export const useAppContext = () => {
    return useContext(AppContext);
}

 const AppProvider = ({ children }) => {

    const {authState} = useAuth(null)
    
    const [menuCollapsed, setMenuCollapsed] = useState(window.innerWidth < 1060 || window.outerWidth < 1060 ? true : false)
    const[filterParams, setFilterParams] = useState({
        page: 1,
        limit: 12,
        department: [],
        hierarchy: [],
        name: '',
        status: 'all',
        date: null,
        number: '',
        sort_params: 'upload_date-desc',
        order: 'desc'
    })

    const [docs, setDocs] = useState([])
    const refreshDocs = () => {
        getDocs(filterParams).then(res => {
            setDocs(res)
        }).catch(error => {
            console.error(error)
        })
    }

    const [menu, setMenu] = useState([])
    const refreshMenu = () => {
        getMenu().then(res => {
            setMenu(res)
        }).catch(error => {
            console.error(error)
        })
    }

    useEffect(() => {
      authState?.authenticated && refreshDocs()
    }, [filterParams, authState])

    useEffect(() => {
      authState?.authenticated && refreshMenu()
    }, [authState])

    useEffect(() => {
        window.addEventListener('resize', () => {
          
          if (window.innerWidth < 1060||window.outerWidth < 1060) {
            setMenuCollapsed(true)
          } else {
            setMenuCollapsed(false)
          }
        })
      }, [])

    const value = {
        menuCollapsed,
        setMenuCollapsed,
        filterParams,
        setFilterParams,
        docs,
        refreshDocs,
        menu,
        refreshMenu
    }
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export { AppContext, AppProvider  };